import { Injectable, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private readonly translate = inject(TranslateService);

  readonly active = signal(false);
  readonly message = signal(this.translate.instant('i18n.Common.loading'));
  readonly showLogo = signal(false);

  show(message?: string, showLogo: boolean = true) {
    this.message.set(message ?? this.translate.instant('i18n.Common.loading'));
    this.showLogo.set(showLogo ?? false);
    this.active.set(true);
  }

  hide() {
    this.active.set(false);
  }
}
